module.exports = __webpack_public_path__ + "img/interac-e.a55585cc.svg";